export default __webpack_public_path__ + "static/media/service_7.7f3435fc.jpg";